const DataUser = [
  { id:"namaLengkap",
    name:"namaLengkap",
    type:"text",
    label:"NAMA",
    value:""
  },
  { id:"nomorRegistrasi",
    name:"nomorRegistrasi",
    type:"number",
    label:"NO REG",
    value: ""
  },
  { id:"prodi",
    name:"prodi",
    type:"text",
    label:"PRODI",
    value:""
  },
  { id:"fakultas",
    name:"fakultas",
    type:"text",
    label:"FAKULTAS",
    value:""
  },
  { id:"tahunMasuk",
    name:"tahunMasuk",
    type:"number",
    label:"ANGKATAN",
    value: ""
  },
  { id:"golonganDarah",
    name:"golonganDarah",
    type:"text",
    label:"GOL. DARAH",
    value: ""
  }
];

export default DataUser